<div class="app-lang">
  <button
    type="button"
    class="app-lang-toggle"
    aria-label="Тіл / Язык"
    (click)="langOpen.set(!langOpen())"
  >
    <nz-icon nzType="global"/>
  </button>

  <div class="app-lang-panel" [class.open]="langOpen()">
    <app-language-switcher/>
  </div>
</div>
<router-outlet />
